/**
 * @param {'pickup' | 'delivery' | string} fulfillmentType
 * @returns {'web_pickup' | 'web_delivery'}
 */
export function mapWebOrderTypeForApi(fulfillmentType) {
  return fulfillmentType === 'pickup' ? 'web_pickup' : 'web_delivery';
}
